import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from 'react-jss'
import { Router } from 'react-router-dom'
import compose from '@shopify/react-compose'

import Routes from 'routes'
import Layout from 'components/layout'
import MainNav from 'components/main-nav'
import ChatLoader from 'components/chat-loader'
import { AppLoader, PageBackground, withConfiguration, withEndUser, DebugConsole, PreviewProvider } from '@portal/kit/pkg/components'

import { global as globalStyles } from '@portal/kit/pkg/styles'

import '@portal/kit/public/fonts.css'
import '@portal/kit/public/icons.css'
import { withRan } from 'components/providers/ran'

class App extends Component {
  isLoading = () => {
    return this.props.user.isUnresolved() || !this.props.portalConfiguration || this.props.isFetching()
  }

  componentDidUpdate() {
    if (this.props.portalConfiguration && this.props.portalConfiguration.is_correct_host === false) {
      window.location.replace(window.location.protocol + '//' + this.props.portalConfiguration.selfcare_host + window.location.pathname + window.location.search)
    }
  }

  render() {
    if (this.isLoading()) {
      return <AppLoader />
    }

    const layoutProps = {
      headerProps: {
        children: this.props.user.data ? <MainNav /> : <div id="page-title" />,
      }
    }

    return (
      <Router history={this.props.history}>
        <PreviewProvider>
          <PageBackground />
          <Layout {...layoutProps}>
            <Routes />
          </Layout>
          <DebugConsole isEnabled={this.props.portalConfiguration.debug} />
          <ChatLoader />
        </PreviewProvider>
      </Router>
    )
  }
}

App.propTypes = {
  portalConfiguration: PropTypes.object,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default compose(
  withStyles(globalStyles),
  withConfiguration,
  withEndUser,
  withRan
)(App)
